/**
 * ntc-filtri.js — la barra dei filtri «viva» (collezioni e ricerca), 11/09/2026.
 *
 * ⭐ Testata rossa con il conto dei ricambi che scorre quando cambia; per ogni gruppo un'icona e quanti filtri sono
 *    accesi; sotto ogni voce una riga lunga quanto la sua fetta di prodotti; «cerca» dentro alle liste lunghe; prezzo
 *    con cursore doppio e fasce rapide; su computer la colonna resta sullo schermo mentre si scorre.
 * ⚠️ facets.js a ogni filtro TOGLIE i gruppi (.js-filter) e li rimette nuovi: quello che si aggiunge dentro ai gruppi
 *    si riaggiunge (MutationObserver). La testata sta fuori dai gruppi e resta.
 * ⛔ facets.js ascolta «input» su TUTTO il modulo: i campi nostri (cerca, cursori) fermano l'evento, altrimenti ogni
 *    lettera ricaricherebbe la griglia. Il cursore scrive nei campi «Da/A» del tema e manda «input» come se li avesse
 *    scritti il cliente: i filtri restano quelli veri del negozio.
 * ⛔ Il tema scriveva il massimo del prezzo come «14.14580»: il massimo si rimette giusto, preso dalla scritta «Il prezzo
 *    più alto è…» (e collection-filters.liquid ora ricava il formato dei soldi davvero).
 * ⭐ Cursore del prezzo in scala LOGARITMICA: col pezzo più caro a 14.146 € una scala dritta metteva 300 € al 2% della
 *    pista. Così 50 € sta verso metà corsa e i valori si arrotondano (5 €, 10 €, 50 €).
 */
(function () {
  'use strict';

  var calma = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = (document.currentScript && document.currentScript.dataset) || {};
  var TITOLO = cfg.titolo || 'Filtra i ricambi';
  var PAROLA = cfg.ricambi || 'ricambi';
  /* ⚠️ «ricambi» → «ricambio», non «ricambo» (11/09: togliere la i finale non basta) */
  var PAROLA_UNO = ({ ricambi: 'ricambio', pezzi: 'pezzo', prodotti: 'prodotto', articoli: 'articolo' })[PAROLA.toLowerCase()] || PAROLA;
  var FASCE = String(cfg.fasce || '50, 150, 500').split(',').map(function (x) { return parseFloat(x); })
    .filter(function (x) { return x > 0; }).sort(function (a, b) { return a - b; });

  var ICONE = {
    tipo: '<svg viewBox="0 0 24 24"><path d="M4 7.5l8-4 8 4-8 4-8-4zm0 4.5l8 4 8-4M4 16.5l8 4 8-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
    prezzo: '<svg viewBox="0 0 24 24"><path d="M16.5 6.8A6.5 6.5 0 1 0 16.5 17.2M4.5 10.2h9M4.5 13.8h9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    disponibile: '<svg viewBox="0 0 24 24"><path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm-4-9l2.8 2.8L16 9.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    auto: '<svg viewBox="0 0 24 24"><path d="M5 11.5l1.5-4.3A2 2 0 018.4 5.8h7.2a2 2 0 011.9 1.4l1.5 4.3m-14 0h14m-14 0v5m14-5v5M7 16.5v1.8m10-1.8v1.8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    marca: '<svg viewBox="0 0 24 24"><path d="M12 3.5l2.5 5.2 5.7.8-4.1 4 1 5.6L12 16.4l-5.1 2.7 1-5.6-4.1-4 5.7-.8z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
    altro: '<svg viewBox="0 0 24 24"><path d="M4 7h9m4 0h3M4 12h3m4 0h9M4 17h11m4 0h1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="15" cy="7" r="2" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="9" cy="12" r="2" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="17" cy="17" r="2" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>',
    cerca: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M16 16l4 4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
  };
  function icona(nome) {
    if (/price/.test(nome)) { return ICONE.prezzo; }
    if (/availability/.test(nome)) { return ICONE.disponibile; }
    if (/model|modello|versione|marca_auto|year|anno|veicol/.test(nome)) { return ICONE.auto; }
    if (/vendor|brand/.test(nome)) { return ICONE.marca; }
    if (/product_type|categoria|category/.test(nome)) { return ICONE.tipo; }
    return ICONE.altro;
  }

  /* ⚠️ it-IT non mette il punto sotto alle 5 cifre («1892»): i punti si mettono a mano */
  function punti(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function numero(t) {
    var m = String(t || '').replace(/[.\s]/g, '').match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  }
  /* ⛔ 12/09: sulla ricerca il conto è «Cerca risultati per “tag:"BMW Serie 3"”: 1.000 articoli» e numero() prendeva il
     PRIMO numero, il 3 di «Serie 3»: la testata diceva «3 ricambi». Vale il numero attaccato alla parola. */
  function contoProdotti(t) {
    var s = String(t || '').replace(/\s+/g, ' ');
    var m = s.match(/(\d[\d.]*)\s*(?:articol|prodott|risultat|ricamb|pezz|element|product|result|item)/i);
    if (m) { return parseInt(m[1].replace(/\./g, ''), 10); }
    var tutti = s.match(/\d[\d.]*/g);
    return tutti ? parseInt(tutti[tutti.length - 1].replace(/\./g, ''), 10) : null;
  }
  /* «Il prezzo più alto è €14,145.80» oppure «€14.145,80» → 14145.8 */
  function prezzoMassimo(t) {
    var m = String(t || '').match(/\d[\d.,]*/g);
    if (!m) { return 0; }
    var s = m[m.length - 1];
    var ul = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    if (ul >= 0 && s.length - ul - 1 === 2) {
      s = s.slice(0, ul).replace(/[.,]/g, '') + '.' + s.slice(ul + 1);
    } else {
      s = s.replace(/[.,]/g, '');
    }
    return parseFloat(s) || 0;
  }

  /* ── la testata: «Filtra i ricambi» + il conto che scorre ─────────────────────────────── */
  var contoMostrato = null;
  function testata() {
    var cont = document.querySelector('#FacetFiltersForm .page-layout-sidebar-inner-content');
    if (!cont || cont.querySelector('.ntc-filtri-testa')) { return; }
    var t = document.createElement('div');
    t.className = 'ntc-filtri-testa';
    t.innerHTML = '<span class="ntc-filtri-testa__righe" aria-hidden="true"><i></i><i></i><i></i><i></i></span>' +
      '<span class="ntc-filtri-testa__eti"></span>' +
      '<strong class="ntc-filtri-testa__conto" aria-live="polite"><span data-ntc="numero"></span><small></small></strong>' +
      '<span class="ntc-filtri-testa__scie" aria-hidden="true"><i></i><i></i><i></i></span>';
    t.querySelector('.ntc-filtri-testa__eti').textContent = TITOLO;
    t.querySelector('small').textContent = PAROLA;
    cont.insertBefore(t, cont.firstChild);
    contoMostrato = null;
    conto();
  }
  function conto() {
    var pc = document.getElementById('ProductCount');
    if (!pc) { return; }
    /* il conto sopra alla griglia col punto delle migliaia («1.892 Prodotti») — idempotente: col punto non ricombacia */
    Array.prototype.forEach.call(pc.childNodes, function (nd) {
      if (nd.nodeType === 3 && /\d{4,}/.test(nd.textContent)) {
        nd.textContent = nd.textContent.replace(/\d{4,}/g, function (x) { return punti(+x); });
      }
    });
    /* 12/09: la ricerca scriveva la domanda tecnica («tag:"BMW Serie 3"»): resta solo il nome */
    Array.prototype.forEach.call(pc.childNodes, function (nd) {
      if (nd.nodeType === 3 && /\b(?:tag|product_type):"/.test(nd.textContent)) {
        nd.textContent = nd.textContent.replace(/\b(?:tag|product_type):"([^"]*)"/g, '$1').replace(/\s+(?:AND|OR)\s+/g, ' · ');
      }
    });
    var el = document.querySelector('.ntc-filtri-testa [data-ntc="numero"]');
    if (!el) { return; }
    var nuovo = contoProdotti(pc.textContent);
    if (nuovo == null || nuovo === contoMostrato) { return; }
    var da = contoMostrato == null ? 0 : contoMostrato;
    contoMostrato = nuovo;
    var box = el.parentNode;
    box.querySelector('small').textContent = nuovo === 1 ? PAROLA_UNO : PAROLA;
    box.classList.remove('is-cambiato');
    void box.offsetWidth;
    box.classList.add('is-cambiato');
    if (calma) { el.textContent = punti(nuovo); return; }
    var t0 = performance.now(), durata = 900;
    (function passo(t) {
      var k = Math.min(1, (t - t0) / durata), e = 1 - Math.pow(1 - k, 3);
      el.textContent = punti(da + (nuovo - da) * e);
      if (k < 1) { requestAnimationFrame(passo); }
    })(t0);
  }

  /* ── versioni dalla più NUOVA, come nella tendina della barra (12/09/2026) ─────────────────────────────
   * [ntc-ordine-versioni] Shopify mette le voci del filtro in ordine alfabetico («E30, E36, E46…» = dalla più vecchia).
   * L'ordine giusto è quello dell'albero della barra (ntc-veicoli.json, già scaricato dalla barra). Le voci accese
   * restano in cima; quelle che l'albero non ha vanno in fondo, nell'ordine in cui erano. */
  var ordineVersioni = null;
  function caricaOrdine() {
    if (ordineVersioni) { return ordineVersioni; }
    var el = document.querySelector('[data-albero]');
    var url = el && el.getAttribute('data-albero');
    ordineVersioni = !url ? Promise.resolve(null) : fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (albero) {
        if (!albero || !albero.forEach) { return null; }
        var posto = {}, i = 0;
        albero.forEach(function (m) {
          (m.m || []).forEach(function (mm) { (mm.v || []).forEach(function (v) { posto[v.t] = i++; }); });
        });
        return posto;
      })
      .catch(function () { return null; });
    return ordineVersioni;
  }
  function ordinaVersioni(f) {
    var lista = f.querySelector('.facet-options-list');
    if (!lista) { return; }
    caricaOrdine().then(function (posto) {
      if (!posto || !lista.isConnected) { return; }
      var righe = Array.prototype.filter.call(lista.children, function (li) { return li.classList.contains('facet-options-list-item'); });
      righe.map(function (li, k) {
        var inp = li.querySelector('input[type="checkbox"]');
        var v = inp ? inp.value : '';
        return { li: li, k: k, acceso: inp && inp.checked ? 0 : 1, p: Object.prototype.hasOwnProperty.call(posto, v) ? posto[v] : 1e9 };
      }).sort(function (a, b) { return a.acceso - b.acceso || a.p - b.p || a.k - b.k; })
        .forEach(function (o) { lista.appendChild(o.li); });
    });
  }

  /* ── «Tipo di prodotto» diviso (12/09/2026) ─────────────────────────────────────────────────────────────────────
   * L'utente: «separati i ricambi di carrozzeria ed estetica dal resto… se uno vuole solo il mondo tuning accede
   * velocemente alle categorie della propria auto». Sopra i tipi del mondo tuning (Impostazioni del tema → NTC · Griglia
   * e filtri), sotto «Altri ricambi» chiuso: si apre col pulsante ed è già aperto se una sua voce è accesa.
   * ⚠️ Le caselle restano quelle del tema (stesso modulo, stessi filtri): cambiano solo l'ordine e cosa si vede.
   * ⚠️ facets.js rifà il gruppo a ogni filtro: la divisione si rifà e «aperto/chiuso» resta com'era (altriAperti). */
  var TIPI_TUNING = "Griglie\nGriglie Fendinebbia\nFront Lip\nParaurti\nDiffusori Posteriori\nSpoiler Posteriori\nBaffi e Flap\nMinigonne\nBodykit\nKit Completi\nSpecchietti\nPedane Laterali\nParafanghi e Passaruota\nCofani e Portelloni\nModanature e Cornici\nAdesivi e Pellicole\nCarrozzeria ed esterni\nTerminali e Marmitte\nVolanti e Pedali\nPomelli Cambio";
  var tipiTuning = {};
  (cfg.tuning != null ? cfg.tuning : TIPI_TUNING).split(/\r?\n|,/).forEach(function (x) {
    x = String(x || '').trim().toLowerCase();
    if (x) { tipiTuning[x] = true; }
  });
  var TITOLO_TUNING = cfg.tuningTitolo || 'Carrozzeria ed estetica';
  var TITOLO_ALTRI = cfg.altriTitolo || 'Altri ricambi';
  var altriAperti = false;
  function somma(righe) {
    return righe.reduce(function (s, li) {
      var c = li.querySelector('.checkbox-facet-label-count');
      return s + (c ? (numero(c.textContent) || 0) : 0);
    }, 0);
  }
  function dividiTipi(f, righe) {
    var lista = f.querySelector('.facet-options-list');
    if (!lista || lista.querySelector('.ntc-tipi-testa')) { return; }
    var sopra = [], sotto = [];
    righe.forEach(function (li) {
      var inp = li.querySelector('input[type="checkbox"]');
      (inp && tipiTuning[String(inp.value).trim().toLowerCase()] ? sopra : sotto).push(li);
    });
    if (!sopra.length || !sotto.length) { return; }
    var t1 = document.createElement('li');
    t1.className = 'ntc-tipi-testa ntc-tipi-testa--tuning';
    t1.innerHTML = '<span class="ntc-tipi-testa__righe" aria-hidden="true"><i></i><i></i><i></i></span><span class="ntc-tipi-testa__nome"></span><small></small>';
    t1.querySelector('.ntc-tipi-testa__nome').textContent = TITOLO_TUNING;
    t1.querySelector('small').textContent = punti(somma(sopra));
    var t2 = document.createElement('li');
    t2.className = 'ntc-tipi-testa ntc-tipi-testa--altri';
    t2.innerHTML = '<button type="button" class="ntc-tipi-altri"><span class="ntc-tipi-testa__nome"></span><small></small><i aria-hidden="true"></i></button>';
    var b = t2.querySelector('button');
    b.querySelector('.ntc-tipi-testa__nome').textContent = TITOLO_ALTRI;
    b.querySelector('small').textContent = punti(somma(sotto));
    lista.appendChild(t1);
    sopra.forEach(function (li) { lista.appendChild(li); });
    lista.appendChild(t2);
    sotto.forEach(function (li) { li.classList.add('ntc-tipo-altro'); lista.appendChild(li); });
    lista.classList.add('ntc-tipi-divisi');
    lista.setAttribute('aria-expanded', 'true');
    var piu = f.querySelector('.facet-button-more');
    if (piu) { piu.hidden = true; }
    var acceso = sotto.some(function (li) { var i = li.querySelector('input[type="checkbox"]'); return !!(i && i.checked); });
    function metti(aperto) {
      lista.classList.toggle('ntc-altri-chiusi', !aperto);
      b.setAttribute('aria-expanded', aperto ? 'true' : 'false');
    }
    metti(altriAperti || acceso);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      altriAperti = lista.classList.contains('ntc-altri-chiusi');
      metti(altriAperti);
    });
  }

  /* ── un gruppo di filtri ─────────────────────────────────────────────────────────────── */
  function gruppo(f) {
    if (f.hasAttribute('data-ntc-pronto')) { return; }
    f.setAttribute('data-ntc-pronto', '');
    var nome = f.getAttribute('data-name') || '';
    var toggle = f.querySelector('.facet-toggle');
    var etichetta = toggle && toggle.querySelector('span');
    var testoEtichetta = etichetta ? etichetta.textContent.trim() : '';

    /* icona e quanti filtri accesi — DENTRO all'etichetta: il tema dà stile a «.facet-toggle > span:first-child» */
    if (etichetta && !etichetta.querySelector('.ntc-filtro-icona')) {
      var ic = document.createElement('span');
      ic.className = 'ntc-filtro-icona';
      ic.setAttribute('aria-hidden', 'true');
      ic.innerHTML = icona(nome);
      etichetta.insertBefore(ic, etichetta.firstChild);
      var accesi = f.querySelectorAll('input[type="checkbox"]:checked').length;
      var prezzoAcceso = /price/.test(nome) && Array.prototype.some.call(f.querySelectorAll('.facet-price-range-field input'), function (i) { return i.value !== ''; });
      if (accesi || prezzoAcceso) {
        var n = document.createElement('span');
        n.className = 'ntc-filtro-accesi';
        n.textContent = prezzoAcceso ? '€' : String(accesi);
        etichetta.appendChild(n);
      }
    }

    /* righe: quanto pesa ogni voce rispetto alla più grande del gruppo (numero da 0 a 1 per il calc del CSS) */
    var righe = Array.prototype.slice.call(f.querySelectorAll('.facet-options-list-item'));
    if (righe.length > 1 && !/availability/.test(nome)) {
      var conti = righe.map(function (li) {
        var c = li.querySelector('.checkbox-facet-label-count');
        return c ? (numero(c.textContent) || 0) : 0;
      });
      var max = Math.max.apply(null, conti);
      if (max > 0) {
        righe.forEach(function (li, i) {
          li.style.setProperty('--ntc-quota', Math.max(0.04, conti[i] / max).toFixed(3));
          li.style.setProperty('--ntc-i', Math.min(i, 14));
          li.classList.add('ntc-con-quota');
        });
      }
    }

    if (/versione/.test(nome) && righe.length > 1) { ordinaVersioni(f); }
    if (/product_type/.test(nome) && righe.length > 1) { dividiTipi(f, righe); }

    /* cerca dentro alle liste lunghe */
    var lista = f.querySelector('.facet-options-list');
    if (lista && righe.length > 10 && !f.querySelector('.ntc-filtro-cerca')) {
      var box = document.createElement('label');
      box.className = 'ntc-filtro-cerca';
      box.innerHTML = ICONE.cerca + '<input type="search" autocomplete="off">';
      var inp = box.querySelector('input');
      inp.placeholder = 'Cerca in ' + testoEtichetta.toLowerCase() + '…';
      inp.setAttribute('aria-label', 'Cerca in ' + testoEtichetta);
      ['input', 'change', 'keydown'].forEach(function (tipo) {
        inp.addEventListener(tipo, function (e) {
          e.stopPropagation();
          if (tipo === 'keydown' && e.key === 'Enter') { e.preventDefault(); }
        });
      });
      inp.addEventListener('input', function () {
        var q = inp.value.trim().toLowerCase();
        lista.classList.toggle('ntc-in-cerca', !!q);
        righe.forEach(function (li) {
          li.hidden = !!q && (li.textContent || '').toLowerCase().indexOf(q) < 0;
        });
      });
      lista.parentNode.insertBefore(box, lista);
    }

    if (/price/.test(nome)) { prezzo(f); }
  }

  /* ── prezzo: cursore doppio (scala logaritmica) + fasce rapide, che scrivono nei campi del tema ── */
  function prezzo(f) {
    var campi = f.querySelectorAll('.facet-price-range-field input');
    var dentro = f.querySelector('price-range');
    if (campi.length < 2 || !dentro || f.querySelector('.ntc-prezzo')) { return; }
    var campoDa = campi[0], campoA = campi[1];
    /* «300.00» nel campo si leggeva «300,» (numero all'italiana, campo stretto): gli zeri finali non servono */
    [campoDa, campoA].forEach(function (c) { if (/\.0+$/.test(c.value)) { c.value = c.value.replace(/\.0+$/, ''); } });
    var testa = f.querySelector('.js-price-range-header');
    var max = Math.ceil(prezzoMassimo(testa ? testa.textContent : '')) || 1000;
    /* ⛔ il massimo scritto dal tema era sbagliato («14.14580»): si rimette quello vero */
    campoA.setAttribute('max', String(max));
    campoDa.setAttribute('max', campoA.value !== '' ? campoA.value : String(max));

    var SCALA = 1000;
    var logMax = Math.log1p(max);
    function tondo(v) {
      if (v < 100) { return Math.round(v / 5) * 5; }
      if (v < 1000) { return Math.round(v / 10) * 10; }
      return Math.round(v / 50) * 50;
    }
    function valore(pos) {
      if (pos <= 0) { return 0; }
      if (pos >= SCALA) { return max; }
      return Math.min(max, tondo(Math.expm1(pos / SCALA * logMax)));
    }
    function posizione(v) {
      if (v <= 0) { return 0; }
      if (v >= max) { return SCALA; }
      return Math.round(Math.log1p(v) / logMax * SCALA);
    }

    var box = document.createElement('div');
    box.className = 'ntc-prezzo';
    box.innerHTML = '<div class="ntc-prezzo__valori"><span data-ntc="da"></span><span data-ntc="a"></span></div>' +
      '<div class="ntc-prezzo__pista"><i class="ntc-prezzo__tratto"></i>' +
      '<input type="range" min="0" step="1" data-ntc="cursore-da" aria-label="Prezzo minimo">' +
      '<input type="range" min="0" step="1" data-ntc="cursore-a" aria-label="Prezzo massimo"></div>' +
      '<div class="ntc-prezzo__fasce"></div>';
    var cDa = box.querySelector('[data-ntc="cursore-da"]'), cA = box.querySelector('[data-ntc="cursore-a"]');
    cDa.max = cA.max = String(SCALA);
    /* i valori ESATTI (dai campi o da una fascia) vincono sull'arrotondamento del cursore finché non lo si muove */
    var esatti = [campoDa.value !== '' ? parseFloat(campoDa.value) : 0, campoA.value !== '' ? parseFloat(campoA.value) : max];
    cDa.value = String(posizione(esatti[0]));
    cA.value = String(posizione(esatti[1]));

    function coppia() {
      if (esatti) { return esatti[0] <= esatti[1] ? esatti : [esatti[1], esatti[0]]; }
      var v1 = valore(+cDa.value), v2 = valore(+cA.value);
      return v1 <= v2 ? [v1, v2] : [v2, v1];
    }
    function disegna() {
      var v = coppia();
      box.style.setProperty('--ntc-da', (posizione(v[0]) / SCALA * 100) + '%');
      box.style.setProperty('--ntc-a', (posizione(v[1]) / SCALA * 100) + '%');
      box.querySelector('[data-ntc="da"]').textContent = '€ ' + punti(v[0]);
      box.querySelector('[data-ntc="a"]').textContent = '€ ' + punti(v[1]) + (v[1] >= max ? '+' : '');
      box.querySelectorAll('.ntc-prezzo__fascia').forEach(function (b) {
        var a = +b.getAttribute('data-a');
        b.classList.toggle('is-attiva', +b.getAttribute('data-da') === v[0] && (a === v[1] || (a >= max && v[1] >= max)));
      });
    }
    function metti(campo, v) {
      if (String(campo.value) === String(v)) { return; }
      campo.value = v;
      campo.dispatchEvent(new Event('input', { bubbles: true }));
    }
    function applica() {
      var v = coppia();
      metti(campoDa, v[0] > 0 ? v[0] : '');
      metti(campoA, v[1] < max ? v[1] : '');
    }
    [cDa, cA].forEach(function (c) {
      c.addEventListener('input', function (e) { e.stopPropagation(); esatti = null; disegna(); });
      c.addEventListener('change', function (e) { e.stopPropagation(); esatti = null; applica(); });
    });

    /* fasce: fino a 50 € · 50–150 € · 150–500 € · oltre 500 € (dalle impostazioni del tema) */
    var soglie = FASCE.filter(function (x) { return x < max; });
    var fasce = box.querySelector('.ntc-prezzo__fasce');
    var bordi = [0].concat(soglie).concat([max]);
    for (var i = 0; i < bordi.length - 1; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ntc-prezzo__fascia';
      b.setAttribute('data-da', bordi[i]);
      b.setAttribute('data-a', bordi[i + 1]);
      b.textContent = i === 0 ? 'fino a ' + punti(bordi[1]) + ' €'
        : (i === bordi.length - 2 ? 'oltre ' + punti(bordi[i]) + ' €' : punti(bordi[i]) + '–' + punti(bordi[i + 1]) + ' €');
      b.addEventListener('click', function () {
        esatti = [+this.getAttribute('data-da'), +this.getAttribute('data-a')];
        cDa.value = String(posizione(esatti[0]));
        cA.value = String(posizione(esatti[1]));
        disegna();
        applica();
      });
      fasce.appendChild(b);
    }
    if (bordi.length < 3) { fasce.hidden = true; }

    dentro.parentNode.insertBefore(box, dentro);
    disegna();
  }

  /* ── colonna che resta sullo schermo (computer): parte sotto a TUTTE le barre incollate in alto ── */
  var appiccica = cfg.appiccica !== 'false';
  var inAttesa = 0;
  /* ⛔ Le barre in alto sono IMPILATE: testata a 0, menu sotto, «Trova i ricambi» incollata sotto al menu (sticky con
     top = testata + menu). Contando solo chi stava a filo dello schermo (top 0) la barra nera restava fuori e,
     scorrendo, la testata della colonna le finiva sotto (11/09). Conta ogni barra INCOLLATA (top = il suo «top» CSS,
     o fixed) e ancora sullo schermo; vale il fondo più basso. */
  function sotto() {
    inAttesa = 0;
    var alto = 0;
    document.querySelectorAll('sticky-header, .shopify-section-group-header-group').forEach(function (el) {
      var st = getComputedStyle(el);
      if (st.position !== 'sticky' && st.position !== 'fixed') { return; }
      var r = el.getBoundingClientRect();
      if (r.bottom <= 0 || r.height >= window.innerHeight * 0.45) { return; }
      var incollata = st.position === 'fixed' || Math.abs(r.top - (parseFloat(st.top) || 0)) <= 2;
      if (incollata && r.bottom > alto) { alto = r.bottom; }
    });
    document.body.style.setProperty('--ntc-filtri-sopra', Math.round(Math.min(alto, 280) + 16) + 'px');
  }

  function giro() {
    testata();
    document.querySelectorAll('#FacetFiltersForm .js-filter:not([data-ntc-pronto])').forEach(gruppo);
    conto();
  }

  if (!document.getElementById('FacetFiltersForm')) { return; }
  document.documentElement.classList.add('ntc-filtri-js');
  if (appiccica) {
    document.body.classList.add('ntc-filtri-appiccicati');
    sotto();
    window.addEventListener('scroll', function () { if (!inAttesa) { inAttesa = requestAnimationFrame(sotto); } }, { passive: true });
    window.addEventListener('resize', sotto);
  }
  giro();
  var attesa = 0;
  new MutationObserver(function () {
    if (attesa) { return; }
    attesa = requestAnimationFrame(function () { attesa = 0; giro(); });
  }).observe(document.querySelector('facet-filters-form') || document.body, { childList: true, subtree: true, characterData: true });
})();
